// src/util/users_util.js
import axios from 'axios';

export const approveMaster = (id) => {
  return axios.patch(`/api/users/approve/${id}`);
};

export const updateStudent = (id, masterId) => {
  return axios.patch(`api/users/students/update/${id}/${masterId}`);
};

export const fetchMasters = () => {
  return axios.get('api/users/all-masters');
};

export const fetchUser = (id) => {
  return axios.get(`/api/users/${id}`);
};

export const fetchStudents = (id) => {
  return axios.get(`api/users/students/${id}`);
};

export const searchStudents = (data) => {
  return axios.get(`api/users/students/search/${data}`);
};

export const updateCredits = (userId, newCredits) => {
  return axios.patch(`/api/users/profiles/${userId}/credits`, { credits: newCredits });
};

export const updateCurrentUser = (userId, data) => {
  const token = localStorage.getItem('jwtToken');
  return axios.patch(
    `/api/users/profilepic/${userId}`,
    data,
    {
      headers: {
        Authorization: `${token}`,
      },
    }
  );
};

// Fetch all users by role
export const fetchUsersByRole = (role) => {
  return axios.get(`/api/users?role=${role}`);
};

export const addCoursesToMaster = (userId, courseIds) => {
  return axios.patch(`/api/users/${userId}/courses`, { courseIds });
};

// Remove courses from a master's eligible courses
export const removeCoursesFromMaster = (masterId, courseIds) => {
  return axios.patch(`/api/users/remove-courses/${masterId}`, { courseIds });
};

export const enrollStudentInCourse = (studentId, courseId) => {
  return axios.patch(`/api/users/${studentId}/enroll-course`, { courseId });
};

// Remove a student from a course
export const removeStudentFromCourse = (studentId, courseId) => {
  return axios.patch(`/api/students/${studentId}/remove-course/${courseId}`);
};

export const fetchCredits = (userId) => {
  return axios.get(`/api/users/profiles/${userId}`);
};

export const fetchInstructors = () => {
  return axios.get('/api/users/instructors');
};

/* =========================
   ✅ NEW: One-time bloodborne upload (global user compliance)
   ========================= */
// form-data: file=<pdf|image>
export const uploadBloodborneCert = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const token = localStorage.getItem('jwtToken');

  return axios.post('/api/users/me/bloodborne-cert', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${token}`,
    },
  });
};
